var indexOf = [].indexOf;

angular.module('app.controllers').controller('ApplicationCtrl', ['$scope', '$route', '$rootScope', 'APIFavorites', '$sce', 'APIInteractions', '$interval', '$cookies', 'APITimes', 'UI', 'APIEvent', '$location', 'APIRead', 'APIStatistics', '$timeout', '$window', '$translate', 'APICheckin'].append(function(self, $route, root, APIFavorites, $sce, APIInteractions, $interval, $cookies, APITimes, UI, APIEvent, $location, APIRead, APIStatistics, $timeout, $window, $translate, APICheckin) {
  var appInterval, i, j, pEls, params, ping;
  self.setLang = function(langKey) {
    return $translate.use(langKey);
  };
  self.getLang = function(langKey) {
    return $translate.use() === langKey;
  };
  APIRead.query({
    entry_type: 'campaign',
    full: true
  }, function(data) {
    return self.campaignsmenu = []; //data
  }, function(response) {
    return UI.notify(false, response.data.error);
  });
  params = $location.search();
  self.trustAsResourceUrl = $sce.trustAsResourceUrl;
  self.trustAsHtml = function(string) {
    return $sce.trustAsHtml(string);
  };
  
  // Favorites list

  self.favorites = [];
  self.getFavorites = function() {
    var ref;
    return APIFavorites.query({
      shortcode: ((ref = root.user) != null ? ref.shortcode : void 0) || root.tuser || 'test',
      tuser: root.tuser || null
    }, function(data) {
      return self.favorites = data;
    });
  };
  self.$on('getFavorites', function(event) {
    return self.getFavorites();
  });
  self.toggleFavs = function(entrycode, entry, shortcode = false) {
    var data, entry_id, entrydata, exhibitor_id, fav_code, fav_codes, fav_index, ref;
    root.activeAction = true;
    if (!shortcode) {
      // request params
      shortcode = ((ref = root.user) != null ? ref.shortcode : void 0) || root.tuser || 'test';
    }
    entrydata = angular.copy(entry);
    exhibitor_id = entrydata.exhibitor_id || entrydata.id;
    if (entrydata.exhibitor_id === 0) {
      exhibitor_id = entrydata.exhibitor_id;
    }
    entry_id = entrydata.entry_id || entrydata.id;
    if (entrydata.entry_id === 0) {
      entry_id = entrydata.entry_id;
    }
    data = entrydata;
    if (entrycode === 'ex') { // no need save data for some entries becauase they saved in database
      data = {};
      entry_id = "";
    }
    fav_code = `${entrycode}${exhibitor_id}${entry_id}`;
    fav_codes = self.favorites.map(function(item) {
      return item.fav_code;
    });
    fav_index = fav_codes.indexOf(fav_code);
    // remove from favorites
    if (fav_index !== -1) {
      if (entrycode === 'cr') {
        return;
      }
      (new APIFavorites()).$delete({
        shortcode: shortcode,
        entrycode: entrycode,
        exhibitor_id: exhibitor_id,
        entry_id: entry_id
      }, function() {
        self.favorites.splice(fav_index, 1);
        if (entrycode === 'ex') { // exhibitors
          self.customStat(exhibitor_id, 'favorite_deleted', `Page ${entrydata.title} was deleted from favorites`);
        }
        if (entrycode === 'do') { // download
          if (exhibitor_id < 20) {
            exhibitor_id = null;
          }
          self.customStat(exhibitor_id, 'favorite_deleted', `File ${entrydata.title} was deleted from favorites`);
        }
        if (entrycode === 'li') { // links
          self.customStat(exhibitor_id, 'favorite_deleted', `Link ${entrydata.title} was deleted from favorites`);
        }
        if (entrycode === 'vi') { // videos
          if (exhibitor_id < 20) {
            exhibitor_id = null;
          }
          self.customStat(exhibitor_id, 'favorite_deleted', `Video ${entrydata.title} was deleted from favorites`);
        }
        if (entrycode === 'us') { // presenter users
          self.customStat(null, 'favorite_deleted', `Contact ${entrydata.name} was deleted from favorites`);
        }
        if (entrycode === 'sl') { // programs
          self.customStat(null, 'favorite_deleted', `Program ${entrydata.title_en || entrydata.title_de || entrydata.title} was deleted from favorites`);
        }
        if (self.at('favs')) {
          return self.$emit('forceFavs', entrycode, null, fav_code);
        }
      }, function(errorData) {
        return console.debug(errorData.data.error);
      });
    } else {
      // save as favorites
      (new APIFavorites(data)).$save({
        shortcode: shortcode,
        entrycode: entrycode,
        exhibitor_id: exhibitor_id,
        entry_id: entry_id
      }, function() {
        // track events
        if (entrycode === 'ex') { // exhibitors
          self.customStat(exhibitor_id, 'favorite_saved', `Page ${entrydata.title} was saved to favorites`);
        }
        if (entrycode === 'do') { // download
          if (exhibitor_id < 20) {
            exhibitor_id = null;
          }
          self.customStat(exhibitor_id, 'favorite_saved', `File ${entrydata.title} was saved to favorites`);
        }
        if (entrycode === 'li') { // links
          self.customStat(exhibitor_id, 'favorite_saved', `Link ${entrydata.title} was saved to favorites`);
        }
        if (entrycode === 'vi') { // videos
          if (exhibitor_id < 20) {
            exhibitor_id = null;
          }
          self.customStat(exhibitor_id, 'favorite_saved', `Video ${entrydata.title} was saved to favorites`);
        }
        if (entrycode === 'us') { // presenter users
          self.customStat(null, 'favorite_saved', `Contact ${entrydata.name} was saved to favorites`);
        }
        if (entrycode === 'sl') { // programs
          self.customStat(null, 'favorite_saved', `Program ${entrydata.title_en || entrydata.title_de || entrydata.title} was saved to favorites`);
        }
        if (entrycode === 'cr') { // contact request
          self.customStat(null, 'contact_request', entrydata.favs_themes, true, null, 'finishContactRequest');
          return;
        }
        entrydata.fav_code = fav_code;
        return self.favorites.push(entrydata);
      }, function(response) {
        return UI.notify(false, response.data.error);
      });
    }
  };
  self.isFavs = function(entrycode, entrydata, check = false) {
    var entry_id, exhibitor_id, fav_code, fav_codes;
    if (!(entrydata != null ? entrydata.exhibitor_id : void 0) && !(entrydata != null ? entrydata.id : void 0)) {
      return false;
    }
    exhibitor_id = entrydata.exhibitor_id || entrydata.id;
    if (entrydata.exhibitor_id === 0) {
      exhibitor_id = entrydata.exhibitor_id;
    }
    entry_id = entrydata.entry_id || entrydata.id || "";
    if (entrydata.entry_id === 0) {
      entry_id = entrydata.entry_id;
    } else if (entrydata.id === 0) {
      entry_id = entrydata.id;
    }
    if (entrycode === 'ex') {
      entry_id = "";
    }
    fav_code = `${entrycode}${exhibitor_id}${entry_id}`;
    fav_codes = self.favorites.map(function(item) {
      return item.fav_code;
    });
    return indexOf.call(fav_codes, fav_code) >= 0;
  };
  self.$watch('favorites', function(newObj, oldObj) {
    if (!newObj) {

    }
  }, true);
  self.joinChat = function(meeting, message = '', openChat = true) {
    var ref;
    if (root.xpo == null) {
      return;
    }
    if (((ref = root.user) != null ? ref.auth_ticket : void 0) == null) {
      return;
    }
    return root.xpo.joinChat(meeting, openChat, message);
  };
  
  // Track events

  self.$on('sendCustomStat', function(event, exhibitor_id, method, description = '') {
    return self.customStat(exhibitor_id, method, description, false);
  });
  self.customStat = function(exhibitor_id = null, method, description = '', action = true, ref_id = null, callback = false) {
    var data, ref, ref1;
    if (action) {
      root.activeAction = true;
    }
    data = {
      method: method,
      description: description
    };
    if (exhibitor_id != null) {
      data.exhibitor_id = exhibitor_id;
    }
    if (ref_id != null) {
      data.ref_id = ref_id;
    }
    return (new APIStatistics(data)).$save({
      _private: (ref = root.user) != null ? ref.auth_ticket : void 0,
      auth_ticket: (ref1 = root.user) != null ? ref1.auth_ticket : void 0,
      page_view_id: root.pageViewId || null
    }, function(response) {
      if (callback) {
        self.$emit(callback);
      }
    }, function(response) {
      return UI.notify(false, response.data.error);
    });
  };
  self.openFile = function(exhibitor_id = null, file_name = '') {
    return self.customStat(exhibitor_id, 'file_open', file_name, false, false);
  };
  self.openLink = function(exhibitor_id = null, link_name = '') {
    return self.customStat(exhibitor_id, 'link_open', link_name, false, false);
  };
  self.ha = function() {
    var ref;
    return (root.session != null) && (((ref = root.user) != null ? ref.auth_ticket : void 0) != null);
  };
  self.allowTooltip = function(skip = false) {
    if (skip) {
      return true;
    }
    if (!self.ha()) {
      return false;
    }
    if ($cookies.get('s_e451_tips_hide') || $cookies.get('s_e451_tips')) {
      return false;
    }
    if (self.at('auth')) {
      return false;
    }
    //return false if root.no_access
    return true;
  };
  self.fa = function() {
    return !$cookies.get('s_e365_theme');
  };
  
  // Slider settings

  self.default3colsSlider = {
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 5000,
    useCSS: false,
    cssEase: 'linear',
    dots: false,
    dotsClass: 'slider-dots',
    customPaging: function(slider, i) {
      if (slider.slideCount === 1 || slider.slideCount === slider.options.slidesToShow) {
        return false;
      }
      return "<a class='slider-dots-item'></a>";
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '24px',
          infinite: true
        }
      }
    ]
  };
  self.defaultImgSlider = {
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    speed: 500,
    fade: true,
    autoplay: false,
    autoplaySpeed: 5000,
    useCSS: false,
    cssEase: 'linear',
    dots: false,
    prevArrow: '<div class="slider-control slider-control-prev"></div>',
    nextArrow: '<div class="slider-control slider-control-next"></div>'
  };
  self.modalData = null;
  self.showDataModal = function(source) {
    return self.$emit('showDataModal', source);
  };
  self.closeDataModal = function() {
    return self.$emit('closeDataModal');
  };
  self.$on('showDataModal', function(event, source) {
    if (self.at('videos-deep')) {
      return self.modalData = source;
    } else {
      if (source.variab) {
        self[source.variab] = source;
        return console.log(self[source.variab], source.variab);
      } else {
        return self.modalData = source;
      }
    }
  });
  self.$on('closeDataModal', function(event) {
    self.modalData = null;
    self.modalData2 = null;
    return self.modalData23 = null;
  });
  self.linkImage = function(with_image = false) {
    return function(item, index, array) {
      if (with_image) {
        return item.link_image != null;
      }
      if (!with_image) {
        return !item.link_image;
      }
    };
  };
  self.openContact = function(email = '', name = '', favs = false) {
    return root.$broadcast('onContactModalOpen', email, name, favs);
  };
  self.onYouTubeIframeAPIReady22 = function(video_id = null, exhibitor_id = null, video_title = '', autoplay = false) {
    if (!video_id) {
      return;
    }
    return $timeout(function() {
      var player;
      return player = new YT.Player(`ytPlayer${video_id}`, {
        videoId: video_id,
        playerVars: {
          enablejsapi: 1,
          showinfo: 0,
          controls: 2,
          autoplay: autoplay ? 1 : 0,
          origin: 'https://unlock-the-future.siemens.com'
        },
        events: {
          'onStateChange': function(event) {
            var playing;
            if (event.data === YT.PlayerState.PLAYING) {
              self.customStat(exhibitor_id, 'video_open', `Video ${video_title} gestartet`);
              return playing = true;
            } else if (event.data === YT.PlayerState.PAUSED) {
              return playing = false;
            }
          }
        }
      });
    }, 5);
  };
  /*
  Profile
  */
  $translate('modals.country.placeholder').then(function(trs) {
    return self.countries = [
      {
        "code": "",
        "label": trs
      },
      {
        "code": "FR",
        "label": "France"
      },
      {
        "code": "BE",
        "label": "Belgium"
      },
      {
        "code": "CH",
        "label": "Switzerland"
      },
      {
        "code": "DZ",
        "label": "Algeria"
      },
      {
        "code": "--",
        "label": "Others"
      }
    ];
  });
  self.countryModalEl = document.getElementById('countryModal');
  if (self.countryModalEl != null) {
    self.countryModal = bootstrap.Modal.getOrCreateInstance(self.countryModalEl);
    self.countryModalEl.addEventListener('show.bs.modal', function(event) {
      return self.$applyAsync();
    });
    self.countryModalEl.addEventListener('hide.bs.modal', function(event) {
      return self.$applyAsync();
    });
  }
  self.saveCountry = function() {
    var ref;
    self.formProccess = true;
    return root.session.$save({
      _private: true,
      auth_ticket: (ref = root.user) != null ? ref.auth_ticket : void 0
    }, function(data) {
      self.formProccess = false;
      $translate('modals.country.thanks').then(function(trs) {
        return UI.notify(true, trs);
      });
      return self.countryModal.hide();
    }, function(errorData) {
      self.formProccess = false;
      return UI.notify(false, errorData.data.error);
    });
  };
  self.$on('showCountryModal', function(event, source) {
    self.countryModal.show();
    return self.$applyAsync();
  });
  self.$on('hideCountryModal', function(event, source) {
    self.countryModal.hide();
    return self.$applyAsync();
  });
  /*
  End profile
  */
  self.videoModalEl = document.getElementById('videoModal');
  self.videoMS = false;
  if (self.videoModalEl != null) {
    self.videoModal = bootstrap.Modal.getOrCreateInstance(self.videoModalEl);
    self.videoModalEl.addEventListener('shown.bs.modal', function(event) {
      // First disable and clean up any existing tracking
      self.videoMS = true;
      return self.$applyAsync();
    });
    self.videoModalEl.addEventListener('hidden.bs.modal', function(event) {
      var a;
      a = YT.get('qweqwe');
      if (a != null ? a.g : void 0) {
        a.stopVideo();
      }
      self.modalData = null;
      self.videoMS = false;
      return self.$applyAsync();
    });
  }
  self.videoModalEl2 = document.getElementById('videoModal2');
  self.videoMS2 = false;
  if (self.videoModalEl2 != null) {
    self.videoModal = bootstrap.Modal.getOrCreateInstance(self.videoModalEl2);
    self.videoModalEl2.addEventListener('shown.bs.modal', function(event) {
      self.videoMS2 = true;
      return self.$applyAsync();
    });
    self.videoModalEl2.addEventListener('hidden.bs.modal', function(event) {
      self.modalData2 = null;
      self.videoMS2 = false;
      return self.$applyAsync();
    });
  }
  pEls = [];
  for (i = j = 0; j <= 5; i = ++j) {
    pEls[`p${i}El`] = document.getElementById(`popover-${i}`);
    pEls[`p${i}El`].addEventListener('show.bs.popover', function(event) {
      if (self.at('home')) {
        self.$broadcast("pauseVideo");
      }
      return self.$applyAsync();
    });
  }
  self.p0 = bootstrap.Popover.getOrCreateInstance(pEls["p0El"]);
  self.showTips = function() {
    var anyPopoverVisible, k, l, popover, ref, ref1, ref2, ref3, visiblePopoverIndex;
    // First check if any popovers are currently displayed
    anyPopoverVisible = false;
    visiblePopoverIndex = null;
    for (i = k = 0; k <= 5; i = ++k) {
      popover = bootstrap.Popover.getOrCreateInstance(pEls[`p${i}El`]);
      if ((ref = popover._popper) != null ? (ref1 = ref.state) != null ? (ref2 = ref1.elements) != null ? (ref3 = ref2.popper) != null ? ref3.classList.contains('show') : void 0 : void 0 : void 0 : void 0) {
        anyPopoverVisible = true;
        visiblePopoverIndex = i;
        break;
      }
    }
// Enable all popovers and hide them (except first if it's visible)
    for (i = l = 0; l <= 5; i = ++l) {
      popover = bootstrap.Popover.getOrCreateInstance(pEls[`p${i}El`]);
      popover.enable();
      if (!(i === 0 && visiblePopoverIndex === 0)) {
        popover.hide();
      }
    }
    // If any popover was visible (except first), or no popovers were visible, show the first one
    if (anyPopoverVisible && visiblePopoverIndex !== 0 || !anyPopoverVisible) {
      return self.p0.show();
    }
  };
  self.$on('displayTips', function(event, skip = false) {
    return $timeout(function() {
      if (self.allowTooltip(skip)) {
        return self.showTips();
      }
    }, 1500);
  });
  pEls["p5El"].addEventListener('hidden.bs.popover', function(event) {
    $cookies.put('s_e451_tips', 1);
    if (self.at('home')) {
      self.$broadcast("playVideo");
    }
    return self.$applyAsync();
  });
  self.nextInfo = function(popover) {
    var next, prev;
    prev = popover - 1;
    next = popover;
    bootstrap.Popover.getOrCreateInstance(pEls[`p${prev}El`]).hide();
    if (root.no_access) {
      if (popover === 1) {
        return self.nextInfo(2);
      }
      if (popover === 4) {
        return self.nextInfo(5);
      }
    }
    return bootstrap.Popover.getOrCreateInstance(pEls[`p${next}El`]).show();
  };
  self.disableInfo = function(popover) {
    $cookies.put('s_e451_tips_hide', 1);
    return self.closeTips(popover);
  };
  self.closeTips = function(popover) {
    var k;
    bootstrap.Popover.getOrCreateInstance(pEls[`p${popover}El`]).hide();
    for (i = k = 0; k <= 5; i = ++k) {
      bootstrap.Popover.getOrCreateInstance(pEls[`p${i}El`]).disable();
    }
    $cookies.put('s_e451_tips', 1);
    if (self.at('home')) {
      return self.$broadcast("playVideo");
    }
  };
  self.$on('closeAllTips', function(event) {
    var k, results;
    self.float = null;
    self.floatVideo = null;
    results = [];
    for (i = k = 0; k <= 5; i = ++k) {
      bootstrap.Popover.getOrCreateInstance(pEls[`p${i}El`]).hide();
      results.push(bootstrap.Popover.getOrCreateInstance(pEls[`p${i}El`]).disable());
    }
    return results;
  });
  $window.onbeforeunload = function(event) {
    console.log('onbeforeunload triggered');
    self.customStat(null, 'close_tab', `Close tab from ${$route.current.$$route.options.title || 'Home'} page`);
    return null;
  };
  self.float = null;
  self.floatVideo = null;
  self.$on('toggleFloatPlayer', function(event) {
    if (self.at('programs')) {
      if (self.float != null) {
        return self.floatVideo = angular.copy(self.float);
      }
    } else {
      return self.floatVideo = null;
    }
  });
  self.$on("changeFloatVideo", function(event, video) {
    return self.float = video;
  });
  root.$on('$destroy', function() {
    return $window.onbeforeunload = void 0;
  });
  // Alert
  self.alertModalEl = document.getElementById('alertModal');
  if (self.alertModalEl != null) {
    self.alertModal = bootstrap.Modal.getOrCreateInstance(self.alertModalEl);
  }
  self.alert = {
    closeable: false,
    lastClosed: null
  };
  ping = function() {
    return APIEvent.get({
      _entry: 'eventdata'
    }, function(data) {
      var wasCloseable;
      // Check if closeable status changed from true to false
      wasCloseable = self.alert.closeable;
      self.alert.closeable = data.alert_closeable;
      
      // If changed from closeable to non-closeable, reset lastClosed
      if (wasCloseable && !self.alert.closeable) {
        self.alert.lastClosed = null;
      }
      // Update modal config
      self.alertModal._config.backdrop = self.alert.closeable ? true : 'static';
      self.alertModal._config.keyboard = self.alert.closeable;
      if (data.alert_visible) {
        if (!self.alert.closeable || (!self.alert.lastClosed || (Date.now() - self.alert.lastClosed) > 180000)) { // 3 minutes
          self.alert.title = data.alert_title;
          self.alert.text = data.alert_text;
          return self.alertModal.show();
        }
      } else {
        return self.alertModal.hide();
      }
    });
  };
  // Add event listener for modal close
  if (self.alertModalEl != null) {
    self.alertModalEl.addEventListener('hidden.bs.modal', function(event) {
      if (self.alert.closeable) {
        return self.alert.lastClosed = Date.now();
      }
    });
  }
  ping();
  return appInterval = $interval(ping, 10000);
}));
